var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import ParticlesBase from 'react-particles';
import { loadFull } from 'tsparticles';
/**
 * Particles ラップコンポーネント
 * @description react-particles のラップコンポーネント
 * @description https://github.com/matteobruni/tsparticles/blob/main/components/solid/README.md
 * @param props
 * @returns
 */
export const Particles = (props) => {
    const { className = '', id, options } = props;
    /**
     * 読み込み処理
     */
    const particlesInit = useCallback((engine) => __awaiter(void 0, void 0, void 0, function* () {
        yield loadFull(engine);
    }), []);
    return (_jsx(ParticlesBase, { className: className, id: id, init: particlesInit, options: options }));
};
